import { Route } from "@angular/router";

import { checkIfLoggedInFn } from "../../core/guards";
import { SubmenuComponent } from "../../shared/components";
import { PageMode } from "../../shared/constants/enums";
import { manageForcastedValuesPageGuards, viewForcastedValuesPageGuards } from "./_guards";
import { ForecastedValuesKpisEditorComponent } from "./kpis/forecasted-values-kpis-editor/forecasted-values-kpis-editor";
import { ForecastedValuesKpisListComponent } from "./kpis/forecasted-values-kpis-list/forecasted-values-kpis-list";
import { ForecastedValuesMetricsEditorComponent } from "./metrics/forecasted-values-metrics-editor/forecasted-values-metrics-editor";
import { ForecastedValuesMetricsListComponent } from "./metrics/forecasted-values-metrics-list/forecasted-values-metrics-list";

const FORECASTED_VALUES_KPIS_ROUTES: Route[] = [
  {
    path: "kpis",
    canActivate: [checkIfLoggedInFn, ...viewForcastedValuesPageGuards],
    children: [
      {
        path: "",
        component: ForecastedValuesKpisListComponent,
        data: {
          breadcrumb: "breadcrumbs.kpi",
          title: "breadcrumbs.kpi",
        },
      },
      {
        path: "edit/:id",
        canActivate: [...manageForcastedValuesPageGuards],
        component: ForecastedValuesKpisEditorComponent,
        data: {
          breadcrumb: "forecasted_values.insert_values",
          title: "forecasted_values.insert_values",
        },
      },
    ],
  },
];

const FORECASTED_VALUES_METRICS_ROUTES: Route[] = [
  {
    path: "metrics",
    canActivate: [checkIfLoggedInFn, ...viewForcastedValuesPageGuards],
    children: [
      {
        path: "",
        component: ForecastedValuesMetricsListComponent,
        data: {
          breadcrumb: "data_entry.metrics",
          title: "data_entry.metrics",
        },
      },
      {
        path: "edit/:id",
        canActivate: [...manageForcastedValuesPageGuards],
        component: ForecastedValuesMetricsEditorComponent,
        data: {
          breadcrumb: "breadcrumbs.metric_edit",
          title: "breadcrumbs.metric_edit",
          pageMode: PageMode.edit,
        },
      },
      {
        path: ":id",
        component: ForecastedValuesMetricsEditorComponent,
        data: {
          breadcrumb: "breadcrumbs.view_metric",
          title: "breadcrumbs.view_metric",
          pageMode: PageMode.view,
        },
      },
    ],
  },
];

export const FORECASTED_VALUES_ROUTES: Route[] = [
  {
    path: "forecasted-values",
    canActivate: [checkIfLoggedInFn, ...viewForcastedValuesPageGuards],
    data: {
      breadcrumb: "forecasted_values.title_plural",
      title: "forecasted_values.title_plural",
    },
    children: [
      {
        path: "",
        component: SubmenuComponent,
      },
      ...FORECASTED_VALUES_KPIS_ROUTES,
      ...FORECASTED_VALUES_METRICS_ROUTES,
    ],
  },
];
